// 吃瓜表情图数据：卡通风贴纸化表情，用于表情库展示
export interface ChiguaSticker {
  id: string;
  phrase: string;
  caption: string;
  tag: string;
  img: string;
  gif?: boolean;
}

export const categoryTabs: { key: string; label: string }[] = [
  { key: 'all', label: '全部表情' },
  { key: 'shock', label: '震惊吃瓜' },
  { key: 'speechless', label: '无语围观' },
  { key: 'grin', label: '偷笑看戏' },
  { key: 'wait', label: '蹲后续' },
  { key: 'sarcasm', label: '阴阳怪气' },
  { key: 'gif', label: '吃瓜动图' },
];

export const stickers: ChiguaSticker[] = [
  {
    id: 's1',
    phrase: '啊这……',
    caption: '吃瓜吃到一半发现主角是自己',
    tag: 'shock',
    img: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20sticker%20style%20illustration%20of%20a%20round%20watermelon%20character%20with%20a%20huge%20shocked%20open%20mouth%20and%20wide%20surprised%20eyes%2C%20holding%20a%20small%20melon%20scoop%2C%20simple%20flat%20design%2C%20soft%20cream%20background%2C%20warm%20vibrant%20colors%2C%20playful%20meme%20expression&width=800&height=800&seq=mel-01&orientation=squarish',
  },
  {
    id: 's2',
    phrase: '这瓜保熟吗',
    caption: '围观前先确认瓜源质量',
    tag: 'grin',
    img: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20sticker%20illustration%20of%20a%20watermelon%20character%20winking%20with%20a%20cheeky%20smile%20holding%20up%20a%20slice%20of%20watermelon%2C%20flat%20vector%20style%2C%20soft%20cream%20background%2C%20warm%20melon%20red%20and%20green%20tones%2C%20playful%20mischief%20expression&width=800&height=800&seq=mel-02&orientation=squarish',
  },
  {
    id: 's3',
    phrase: '静静看你装',
    caption: '前排围观，不发表评论',
    tag: 'speechless',
    img: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20sticker%20of%20a%20calm%20watermelon%20character%20with%20flat%20deadpan%20face%2C%20slightly%20squinted%20eyes%2C%20arms%20crossed%2C%20neutral%20unimpressed%20expression%2C%20flat%20vector%20illustration%2C%20soft%20cream%20background%2C%20subtle%20melon%20color%20palette&width=800&height=800&seq=mel-03&orientation=squarish',
  },
  {
    id: 's4',
    phrase: '蹲个后续',
    caption: '瓜没吃完，坚决不走',
    tag: 'wait',
    img: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20sticker%20illustration%20of%20a%20watermelon%20character%20leaning%20forward%20excitedly%20with%20hands%20together%2C%20sparkling%20eager%20eyes%2C%20waiting%20curiously%2C%20flat%20vector%20style%2C%20cream%20background%2C%20warm%20melon%20red%20and%20green%20tones&width=800&height=800&seq=mel-04&orientation=squarish',
  },
  {
    id: 's5',
    phrase: '原来如此啊',
    caption: '恍然大悟的吃瓜瞬间',
    tag: 'shock',
    img: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20sticker%20of%20a%20watermelon%20character%20with%20a%20lightbulb%20moment%2C%20one%20hand%20on%20chin%2C%20eyes%20wide%20in%20realization%2C%20flat%20vector%20style%2C%20soft%20cream%20background%2C%20playful%20meme%20expression%2C%20warm%20colors&width=800&height=800&seq=mel-05&orientation=squarish',
  },
  {
    id: 's6',
    phrase: '乐死我了',
    caption: '看到搞笑反转，忍不住笑出声',
    tag: 'grin',
    img: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20sticker%20illustration%20of%20a%20watermelon%20character%20laughing%20loudly%20with%20tears%20of%20joy%2C%20mouth%20wide%20open%2C%20eyes%20closed%20in%20laughter%2C%20flat%20vector%20style%2C%20cream%20background%2C%20vibrant%20fun%20colors&width=800&height=800&seq=mel-06&orientation=squarish',
  },
  {
    id: 's7',
    phrase: '别装了好吧',
    caption: '一眼看穿你又在演',
    tag: 'sarcasm',
    img: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20sticker%20of%20a%20watermelon%20character%20with%20a%20knowing%20smirk%2C%20raised%20eyebrow%2C%20side%20eye%20expression%2C%20flat%20vector%20illustration%2C%20soft%20cream%20background%2C%20sarcastic%20playful%20meme%20mood&width=800&height=800&seq=mel-07&orientation=squarish',
  },
  {
    id: 's8',
    phrase: '与我无瓜',
    caption: '装路人，实则全程在线',
    tag: 'speechless',
    img: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20sticker%20illustration%20of%20a%20watermelon%20character%20innocently%20whistling%20and%20looking%20away%2C%20acting%20nonchalant%2C%20flat%20vector%20style%2C%20cream%20background%2C%20soft%20melon%20color%20palette%2C%20playful&width=800&height=800&seq=mel-08&orientation=squarish',
  },
  {
    id: 's9',
    phrase: '吃瓜群众集合',
    caption: '搬好小板凳，前排就座',
    tag: 'wait',
    img: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20sticker%20of%20a%20watermelon%20character%20sitting%20on%20a%20tiny%20stool%20with%20a%20bag%20of%20snacks%2C%20ready%20and%20curious%2C%20flat%20vector%20illustration%2C%20soft%20cream%20background%2C%20warm%20melon%20tones%2C%20playful&width=800&height=800&seq=mel-09&orientation=squarish',
  },
  {
    id: 's10',
    phrase: '这也太离谱',
    caption: '剧情走向完全超出预料',
    tag: 'shock',
    img: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20sticker%20illustration%20of%20a%20watermelon%20character%20facepalming%20in%20disbelief%2C%20eyes%20half%20closed%2C%20shaking%20head%2C%20flat%20vector%20style%2C%20soft%20cream%20background%2C%20amused%20shocked%20meme%20expression&width=800&height=800&seq=mel-10&orientation=squarish',
  },
  {
    id: 's11',
    phrase: '我不是我没吃',
    caption: '嘴上否认，手里瓜不停',
    tag: 'sarcasm',
    img: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20sticker%20of%20a%20watermelon%20character%20guiltily%20hiding%20a%20melon%20slice%20behind%20its%20back%20while%20smiling%20nervously%2C%20flat%20vector%20illustration%2C%20cream%20background%2C%20warm%20melon%20colors%2C%20playful%20meme&width=800&height=800&seq=mel-11&orientation=squarish',
  },
  {
    id: 's12',
    phrase: '我滴妈呀',
    caption: '大瓜爆出来的那一秒',
    tag: 'shock',
    img: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20sticker%20illustration%20of%20a%20watermelon%20character%20with%20hands%20on%20cheeks%20in%20amazement%2C%20gasping%2C%20huge%20sparkle%20eyes%2C%20flat%20vector%20style%2C%20soft%20cream%20background%2C%20vibrant%20surprised%20meme%20expression&width=800&height=800&seq=mel-12&orientation=squarish',
  },
  {
    id: 's13',
    phrase: '好家伙我直接好家伙',
    caption: '被剧情反复打脸的名场面',
    tag: 'shock',
    img: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20sticker%20of%20a%20watermelon%20character%20holding%20two%20melon%20halves%2C%20one%20in%20each%20hand%2C%20jaw%20dropped%20in%20double%20surprise%2C%20flat%20vector%20illustration%2C%20cream%20background%2C%20warm%20playful%20colors&width=800&height=800&seq=mel-13&orientation=squarish',
  },
  {
    id: 's14',
    phrase: '看戏模式开启',
    caption: '本人纯属路过，刚好围观',
    tag: 'grin',
    img: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20sticker%20illustration%20of%20a%20watermelon%20character%20wearing%20tiny%20sunglasses%20eating%20popcorn%2C%20enjoying%20a%20show%2C%20flat%20vector%20style%2C%20soft%20cream%20background%2C%20fun%20meme%20expression&width=800&height=800&seq=mel-14&orientation=squarish',
  },
];

export const gifMeme: ChiguaSticker[] = [
  {
    id: 'g1',
    phrase: '疯狂吃瓜中',
    caption: '左右开弓，根本停不下来',
    tag: 'gif',
    gif: true,
    img: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20animated%20style%20watermelon%20character%20eating%20melon%20slices%20rapidly%2C%20motion%20lines%20around%20it%2C%20excited%20expression%2C%20flat%20vector%20illustration%2C%20cream%20background%2C%20energetic%20playful%20colors&width=800&height=800&seq=mel-gif1&orientation=squarish',
  },
  {
    id: 'g2',
    phrase: '瞳孔地震',
    caption: '震惊到失去表情管理',
    tag: 'gif',
    gif: true,
    img: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20animated%20style%20watermelon%20character%20with%20trembling%20shock%20lines%2C%20vibrating%20body%2C%20huge%20surprised%20eyes%2C%20flat%20vector%20illustration%2C%20cream%20background%2C%20dramatic%20playful%20meme&width=800&height=800&seq=mel-gif2&orientation=squarish',
  },
  {
    id: 'g3',
    phrase: '蹲后续蹲到天亮',
    caption: '熬夜也要等一个结局',
    tag: 'gif',
    gif: true,
    img: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20animated%20style%20watermelon%20character%20checking%20a%20phone%20excitedly%20with%20sparkle%20effects%2C%20flat%20vector%20illustration%2C%20cream%20background%2C%20curious%20playful%20meme%20mood&width=800&height=800&seq=mel-gif3&orientation=squarish',
  },
  {
    id: 'g4',
    phrase: '坐等反转',
    caption: '剧情即将高能预警',
    tag: 'gif',
    gif: true,
    img: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20animated%20style%20watermelon%20character%20with%20a%20playful%20grin%20and%20twinkling%20eyes%20anticipating%20a%20plot%20twist%2C%20flat%20vector%20illustration%2C%20cream%20background%2C%20warm%20energetic%20colors&width=800&height=800&seq=mel-gif4&orientation=squarish',
  },
];

export const stickersAll: ChiguaSticker[] = [...stickers, ...gifMeme];